export default __webpack_public_path__ + "003-flash-drive.svg";